import { CapacityFilter } from '../../../components/capacity-filter-panel/capacity-filter-panel';

const GIGABYTE = 1000 * 1000 * 1000;

export const capacityPanelTitle = 'Capacity';

export const capacityFilterList: CapacityFilter[] = [
  { id: 1, label: 'Up to 1 GB', maxBytes: 1 * GIGABYTE, selected: false },
  { id: 2, label: '2 GB', minBytes: 1 * GIGABYTE, maxBytes: 2 * GIGABYTE, selected: false },
  { id: 3, label: '4 GB', minBytes: 2 * GIGABYTE, maxBytes: 4 * GIGABYTE, selected: false },
  { id: 4, label: '8 GB', minBytes: 4 * GIGABYTE, maxBytes: 8 * GIGABYTE, selected: false },
  { id: 5, label: '16 GB', minBytes: 8 * GIGABYTE, maxBytes: 16 * GIGABYTE, selected: false },
  { id: 6, label: '32 GB', minBytes: 16 * GIGABYTE, maxBytes: 32 * GIGABYTE, selected: false },
  { id: 7, label: '64 GB', minBytes: 32 * GIGABYTE, maxBytes: 64 * GIGABYTE, selected: false },
  { id: 8, label: '128 GB', minBytes: 64 * GIGABYTE, maxBytes: 128 * GIGABYTE, selected: false },
  { id: 9, label: '512 GB & Above', minBytes: 128 * GIGABYTE, selected: false },
];
